module.exports = __webpack_public_path__ + "img/samap.039de41c.png";